import { Injectable } from '@angular/core';
import { HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { environment } from "../../../environments/environment";
import { Store } from '@ngrx/store';
import { AppState } from '../state/app.state';
import { switchMap, take } from 'rxjs/operators';

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {

  constructor(private store: Store<AppState>) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return this.store.select(state => state.uiSettings?.showTestData).pipe(
      take(1),
      switchMap(showTestData => {
        let headers = new HttpHeaders();
        headers = headers.append('X-Platform', environment.platform);
        headers = headers.append('X-Version', environment.version);

        if (showTestData !== null && showTestData !== undefined) {
          headers = headers.append('X-ShowTestData', showTestData.toString());
        }

        const modifiedReq = req.clone({
          headers: headers
        });
        return next.handle(modifiedReq);
      })
    );
  }
}
